module.exports = (__webpack_require__(9))(10);


//////////////////
// WEBPACK FOOTER
// delegated ./assets/js/fields/decorators/with-store.js from dll-reference carbon.core
// module id = 53
// module chunks = 0